import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {TreeSelect} from "primereact/treeselect";
import moment from "moment";
import {MultiSelect} from "primereact/multiselect";
import {Panel} from "primereact/panel";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {addLocale} from "primereact/api";
import {AutoComplete} from "primereact/autocomplete";
import {TriStateCheckbox} from "primereact/tristatecheckbox";
import download from 'js-file-download';
import currencyFormatter from "currency-formatter";
import {useHistory} from "react-router-dom";
import {Calendar} from "primereact/calendar";

import {Dialog} from "primereact/dialog";
import ReceiptDeliverynoteInvoiceComponent from "../../../2.0/receipt/ReceiptDeliverynoteInvoiceComponent";
import {Badge} from "primereact/badge";
import {InputMask} from "primereact/inputmask";
import FilequeueListComponent from "../../../2.0/filequeue/FilequeueListComponent";
import axios from "axios";
import {SplitButton} from "primereact/splitbutton";

const ReceiptListComponent = (props) => {

  const {t, onDetailedSearchActiveChange} = props;
  const history = useHistory();
  const DEFAULT_SORT_FIELD = 'delivery_date';
  const DEFAULT_SORT_ORDER = -1;
  const DEFAULT_FILTERS = {
    in_review: { value: false, matchMode: 'equals' }
  };
  const defaultRows = Number(process.env.REACT_APP_LIST_ROW_DEFAULT);
  const saved = (() => {
    try {
      const raw = localStorage.getItem('lastReceiptFilter');
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  })();
  const [lazyParams, setLazyParams] = useState(() => {
    if (saved) {
      return {
        first: saved.first ?? 0,
        rows: saved.rows ?? defaultRows,
        page: saved.page ?? 0,
        sortField: saved.sortField || DEFAULT_SORT_FIELD,
        sortOrder: typeof saved.sortOrder === 'number' ? saved.sortOrder : DEFAULT_SORT_ORDER,
        filters: {
          ...DEFAULT_FILTERS,
          ...(saved.filters || {})
        }
      };
    }
    return {
      first: 0,
      rows: defaultRows,
      page: 0,
      sortField: DEFAULT_SORT_FIELD,
      sortOrder: DEFAULT_SORT_ORDER,
      filters: DEFAULT_FILTERS,
    };
  });
  const [dateInvalid, setDateInvalid] = useState({});
  const [filterSupplierName, setFilterSupplierName] = useState(lazyParams.filters?.company_name?.value || '');
  const [filterCustomerName, setFilterCustomerName] = useState(lazyParams.filters?.partner_name?.value || '');
  const [filterNetAmountMin, setFilterNetAmountMin] = useState(lazyParams.filters?.netAmountMin?.value || null);
  const [filterNetAmountMax, setFilterNetAmountMax] = useState(lazyParams.filters?.netAmountMax?.value || null);
  const [filterIssueDateFrom, setFilterIssueDateFrom] = useState(lazyParams.filters?.issueDateFrom?.value || '');
  const [filterIssueDateTo, setFilterIssueDateTo] = useState(lazyParams.filters?.issueDateTo?.value || '');
  const [filterDeliveryDateFrom, setFilterDeliveryDateFrom] = useState(lazyParams.filters?.deliveryDateFrom?.value || '');
  const [filterDeliveryDateTo, setFilterDeliveryDateTo] = useState(lazyParams.filters?.deliveryDateTo?.value || '');
  const [filterPaymentDateFrom, setFilterPaymentDateFrom] = useState(lazyParams.filters?.paymentDateFrom?.value || '');
  const [filterPaymentDateTo, setFilterPaymentDateTo] = useState(lazyParams.filters?.paymentDateTo?.value || '');
  const [filterRetentionPaymentDateFrom, setFilterRetentionPaymentDateFrom] = useState(lazyParams.filters?.retentionPaymentDateFrom?.value || '');
  const [filterRetentionPaymentDateUntil, setFilterRetentionPaymentDateUntil] = useState(lazyParams.filters?.retentionPaymentDateUntil?.value || '');
  const [filterPaidDateFrom, setFilterPaidDateFrom] = useState(lazyParams.filters?.paidDateFrom?.value || '');
  const [filterPaidDateTo, setFilterPaidDateTo] = useState(lazyParams.filters?.paidDateTo?.value || '');
  const [filterReceiptNumber, setFilterReceiptNumber] = useState(lazyParams.filters?.receipt_number?.value || '');
  
  const [filterPaid, setFilterPaid] = useState(lazyParams.filters?.isPaid?.value ?? null);
  const [filterAllowed, setFilterAllowed] = useState(lazyParams.filters?.allowed?.value ?? null);
  const [filterIncome, setFilterIncome] = useState(lazyParams.filters?.outgoing?.value ?? null);
  
  const [selectedReceiptType, setSelectedReceiptType] = useState(lazyParams.filters?.receiptType?.value || null);
  const [selectedPartnerType, setSelectedPartnerType] = useState(lazyParams.filters?.partnerType?.value || null);

  const [receipt, setReceipt] = useState([]);
  const [selectedReceipts, setSelectedReceipts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [receipttypes, setReceipttypes] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(lazyParams.rows || Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [sum, setSum] = useState({});
  const [downloadDialog, setDownloadDialog] = useState(false);
  const [receiptgroups, setReceiptgroups] = useState([]);
  const [searchCollapsed, setSearchCollapsed] = useState(true);
  const [costCenters, setCostCenters] = useState([]);
  const [costTypes, setCostTypes] = useState([]);

  const [detailedSearchVisible, setDetailedSearchVisible] = useState(false);
  // const [dsReceiptGroup, setDsReceiptGroup] = useState(lazyParams.filters?.receipt_group?.value || null);
  const [dsReceiptGroup, setDsReceiptGroup] = useState(
    props.receiptGroup || lazyParams.filters?.receipt_group?.value || null
  );
  const [dsReceiptType, setDsReceiptType] = useState(lazyParams.filters?.receipt_type?.value || null);
  const [dsIssueDateFrom, setDsIssueDateFrom] = useState(null);
  const [dsIssueDateTo, setDsIssueDateTo] = useState(null);
  const [dsPaymentDateFrom, setDsPaymentDateFrom] = useState(null);
  const [dsPaymentDateTo, setDsPaymentDateTo] = useState(null);
  const [dsDeliveredDateFrom, setDsDeliveredDateFrom] = useState(null);
  const [dsDeliveredDateTo, setDsDeliveredDateTo] = useState(null);
  const [detailedSearchQuery, setDetailedSearchQuery] = useState(saved?.detailedSearchQuery || '');
  const isDetailedSearchActive = React.useMemo(() => {
    return (detailedSearchQuery || '').toString().trim().length > 0;
  }, [detailedSearchQuery]);
  const [dsReceiptNumber, setDsReceiptNumber] = useState('');
  const [dsIsPaid, setDsIsPaid] = useState(null);
  const [dsDraft, setDsDraft] = useState(null);
  const [dsStorno, setDsStorno] = useState(null);
  const [dsCostPosted, setDsCostPosted] = useState(null);
  const [dsCurrency, setDsCurrency] = useState(null);
  const [dsCostCenter, setDsCostCenter] = useState(null);
  const [dsCostType, setDsCostType] = useState(null);
  const [dsNetAmountMin, setDsNetAmountMin] = useState(null);
  const [dsNetAmountMax, setDsNetAmountMax] = useState(null);
  const [dsVatAmountMin, setDsVatAmountMin] = useState(null);
  const [dsVatAmountMax, setDsVatAmountMax] = useState(null);
  const [dsGrossAmountMin, setDsGrossAmountMin] = useState(null);
  const [dsGrossAmountMax, setDsGrossAmountMax] = useState(null);
  const [dsPartner, setDsPartner] = useState(lazyParams.filters?.partner_name?.value || '');

  const [costCentersLoading, setCostCentersLoading] = useState(false);
  const [costTypesLoading, setCostTypesLoading] = useState(false);

  const DS_STORAGE_KEY = 'lastReceiptDetailedSearchForm';

  const fixedReceiptGroup = props.receiptGroup || null;
  const isFixedReceiptGroupList = !!fixedReceiptGroup;

  const persistListState = (state) => {
    localStorage.setItem('lastReceiptFilter', JSON.stringify({
      ...state,
      sortField: state?.sortField || DEFAULT_SORT_FIELD,
      sortOrder: typeof state?.sortOrder === 'number' ? state.sortOrder : DEFAULT_SORT_ORDER,
    }));
  };

  const persistDetailedForm = () => {
    const payload = {
      dsPartner,
      dsReceiptNumber,
      dsReceiptGroup,
      dsReceiptType,
      dsCurrency,
      dsCostCenter,
      dsCostType,
      dsIsPaid,
      dsDraft,
      dsStorno,
      dsCostPosted,
      dsIssueDateFrom,
      dsIssueDateTo,
      dsPaymentDateFrom,
      dsPaymentDateTo,
      dsDeliveredDateFrom,
      dsDeliveredDateTo,
      dsNetAmountMin,
      dsNetAmountMax,
      dsVatAmountMin,
      dsVatAmountMax,
      dsGrossAmountMin,
      dsGrossAmountMax,
    };
    localStorage.setItem(DS_STORAGE_KEY, JSON.stringify(payload));
  };

  const clearDetailedFormPersist = () => {
    localStorage.removeItem(DS_STORAGE_KEY);
  };

  const isPicker = props?.view === 'search' && !!props?.backlink && !!props?.pickParam;
  const goPick = (rowData) => {
    if (!isPicker) return;
    const pickedId = Number(rowData?.id);
    if (!pickedId) return;
    const base = props.backlink;
    const sep = base.includes('?') ? '&' : '?';
    history.push(`${base}${sep}${props.pickParam}=${pickedId}`);
  };

  const dt = useRef(null);

  const safeToastShow = (severity, summary, detail) => {
      if (window.App && typeof window.App.toastShow === 'function') {
        window.App.toastShow(severity, summary, detail);
      } else {
        console.error(`Toast Error (${severity}): ${summary} - ${detail}`);
      }
  };

  const parseCalendarRangeValue = (from, to) => {
    const values = [];
    const fromMoment = from ? moment(from, 'YYYY-MM-DD', true) : null;
    const toMoment = to ? moment(to, 'YYYY-MM-DD', true) : null;
    if (fromMoment && fromMoment.isValid()) {
      values.push(fromMoment.toDate());
    }
    if (toMoment && toMoment.isValid()) {
      values.push(toMoment.toDate());
    }
    return values.length ? values : null;
  };

  const handleCalendarRangeChange = (range, setFrom, setTo, fromKey, toKey) => {
    const [from, to] = range || [];
    if (!from) {
      setFrom(null);
      setTo(null);
      setDateInvalidFlag(fromKey, false);
      setDateInvalidFlag(toKey, false);
      return;
    }
    setFrom(moment(from).format('YYYY-MM-DD'));
    setTo(to ? moment(to).format('YYYY-MM-DD') : null);
    setDateInvalidFlag(fromKey, false);
    setDateInvalidFlag(toKey, false);
  };
  
  const buildDateSearchParams = (field, from, to) => {
    if (from && to) {
      return `search[${field}][operator]=between&search[${field}][value]=${from} 00:00:00,${to} 23:59:59`;
    }
    if (from && !to) {
      return `search[${field}][operator]=>=&search[${field}][value][]=${from} 00:00:00`;
    }
    if (!from && to) {
      return `search[${field}][operator]=<=&search[${field}][value][]=${to} 23:59:59`;
    }
    return '';
  };

  const buildDetailedSearchQuery = () => {
    let parts = [];
    if (dsReceiptNumber && dsReceiptNumber.toString().trim() !== '') {
      const val = dsReceiptNumber.toString().trim();
      parts.push(
        `search[receipt_number][operator]=like&search[receipt_number][value]=*${encodeURIComponent(val)}*`
      );
    }
    if (dsPartner && dsPartner.toString().trim() !== '') {
      parts.push(
        `search[partner_name][operator]=like&search[partner_name][value]=*${encodeURIComponent(dsPartner.toString().trim())}*`
      );
    }
    if (dsReceiptGroup && !props.receiptGroup) {
      parts.push(`search[receipt_group][operator]==&search[receipt_group][value][]=${dsReceiptGroup}`);
    }
    if (dsReceiptType) {
      parts.push(`search[receipt_type][operator]==&search[receipt_type][value][]=${dsReceiptType}`);
    }
    if (dsIsPaid !== null) {
      parts.push(`search[is_paid][operator]==&search[is_paid][value]=${dsIsPaid}`);
    }
    if (dsDraft !== null) {
      parts.push(`search[draft][operator]==&search[draft][value]=${dsDraft}`);
    }
    if (dsStorno !== null) {
      parts.push(`search[storno][operator]==&search[storno][value]=${dsStorno}`);
    }
    if (dsCostPosted !== null) {
      parts.push(`search[cost_posted][operator]==&search[cost_posted][value]=${dsCostPosted}`);
    }
    if (dsCurrency) {
      parts.push(`search[currency][operator]==&search[currency][value]=${dsCurrency}`);
    }
    if (dsCostCenter) {
      parts.push(`search[cost_center][operator]==&search[cost_center][value]=${dsCostCenter}`);
    }
    if (dsCostType) {
      parts.push(`search[cost_type][operator]==&search[cost_type][value]=${dsCostType}`);
    }
    const net = buildAmountSearchParams('net_amount', dsNetAmountMin, dsNetAmountMax);
    if (net) parts.push(net);
    const vat = buildAmountSearchParams('vat_amount', dsVatAmountMin, dsVatAmountMax);
    if (vat) parts.push(vat);
    const gross = buildAmountSearchParams('gross_amount', dsGrossAmountMin, dsGrossAmountMax);
    if (gross) parts.push(gross);
    const issue = buildDateSearchParams('issue_date', dsIssueDateFrom, dsIssueDateTo);
    if (issue) parts.push(issue);
    const payment = buildDateSearchParams('payment_date', dsPaymentDateFrom, dsPaymentDateTo);
    if (payment) parts.push(payment);
    const delivered = buildDateSearchParams('delivery_date', dsDeliveredDateFrom, dsDeliveredDateTo);
    if (delivered) parts.push(delivered);
    return parts.filter(Boolean).join('&');
  };

  const buildAmountSearchParams = (field, min, max) => {
    if (min !== null && max !== null) {
      return `search[${field}][operator]=between&search[${field}][value]=${min},${max}`;
    }
    if (min !== null) {
      return `search[${field}][operator]=>=&search[${field}][value]=${min}`;
    }
    if (max !== null) {
      return `search[${field}][operator]=<=&search[${field}][value]=${max}`;
    }
    return '';
  };

  const loadFilterOptions = () => {
    if (costCenters.length === 0) {
      setCostCentersLoading(true);
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/cost-center/tree",
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        const items = response?.data?.data?.items || [];
        setCostCenters(items);
      })
      .catch(error => console.error("Cost center error", error))
      .finally(() => setCostCentersLoading(false));
    }
    if (costTypes.length === 0) {
      setCostTypesLoading(true);
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_HOST + "/api/v2/cost-type?sort=name&direction=asc&item_per_page=9999",
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }
      })
      .then(response => {
        setCostTypes(response?.data?.data?.items || []);
      })
      .catch(error => console.error("Cost type error", error))
      .finally(() => setCostTypesLoading(false));
    }
  };

  const setDateInvalidFlag = (key, isInvalid) => {
    setDateInvalid(prev => ({ ...prev, [key]: !!isInvalid }));
  };

  const formatCurrency = (currency, amount) => {
    if (window.App && typeof window.App.currencyFormatter === 'function') {
      return window.App.currencyFormatter(currency, amount)
    }
    return <>{amount}&nbsp;{currency}</>
  }

  const fetchReceiptDownloadPdfService = (receiptId) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + receiptId + "/download/pdf", {
      responseType: 'blob',
      params: {},
      headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
      })
  };

  const fetchReceiptList = (queryOrParams) => {
    let query = queryOrParams;
    let extraDetailed = '';
    if (queryOrParams && typeof queryOrParams === 'object' && queryOrParams !== null) {
      extraDetailed = queryOrParams.detailedSearchQuery || '';
      try {
        let paramsForTransform = {...queryOrParams};
        delete paramsForTransform.detailedSearchQuery;
        if (window.App && typeof window.App.transformQueryParams === 'function') {
          query = window.App.transformQueryParams(paramsForTransform);
        } else {
          query = JSON.stringify(paramsForTransform);
        }
      } catch (e) {
        console.error('ReceiptListService query transform error:', e);
        query = queryOrParams;
      }
    } else {
      try {
        if (typeof queryOrParams === 'string' && queryOrParams.trim().startsWith('{')) {
          const parsed = JSON.parse(queryOrParams);
          extraDetailed = parsed?.detailedSearchQuery || '';
          delete parsed.detailedSearchQuery;

          if (window.App && typeof window.App.transformQueryParams === 'function') {
            query = window.App.transformQueryParams(parsed);
          } else {
            query = queryOrParams;
          }
        }
      } catch (e) {
        console.error('ReceiptListService query transform error:', e);
        query = queryOrParams;
      }
    }
    if (query && query.toString().includes(',"multiSortMeta":[]')) {
      query = query.replace(',"multiSortMeta":[]', '');
    }
    if (extraDetailed) {
      if (!query || query.toString().length === 0) {
        query = '?' + extraDetailed;
      } else if (query.toString().includes('?')) {
        query = query + (query.toString().endsWith('?') || query.toString().endsWith('&') ? '' : '&') + extraDetailed;
      } else {
        query = '?' + query + '&' + extraDetailed;
      }
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/receipt" + query,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    });
  };

  const fetchReceiptGroupList = (queryOrParams) => {
    let query = queryOrParams;
    try {
      if (typeof queryOrParams === 'string' && queryOrParams.trim().startsWith('{')) {
        const parsed = JSON.parse(queryOrParams);
        if (window.App && typeof window.App.transformQueryParams === 'function') {
          query = window.App.transformQueryParams(parsed);
        } else {
          query = queryOrParams;
        }
      } else if (typeof queryOrParams === 'object' && queryOrParams !== null) {
        if (window.App && typeof window.App.transformQueryParams === 'function') {
          query = window.App.transformQueryParams(queryOrParams);
        } else {
          query = JSON.stringify(queryOrParams);
        }
      }
    } catch (e) {
      console.error('ReceiptgroupListService query transform error:', e);
      query = queryOrParams;
    }
    if (query && query.toString().includes(',"multiSortMeta":[]')) {
      query = query.replace(',"multiSortMeta":[]', '');
    }
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/receipt-group?" + query,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId"),
      }
    });
  };


  let loadLazyTimeout = null;
    const loadLazyData = () => {
    setLoading(true);
    persistListState(lazyParams);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      if (window.App && window.App.setState) {
        window.App.setState({ rerenderReceiptList: false })
      }

      let _lazyParams = { ...lazyParams };

      if (props.receiptGroup) {
        const cleanedFilters = { ...(lazyParams.filters || {}) };
        delete cleanedFilters.receipt_group;
        delete cleanedFilters.receiptGroup;
        delete cleanedFilters.receiptType;
        delete cleanedFilters.receipt_type;
        _lazyParams.filters = {
          ...cleanedFilters,
          receipt_group: {
            value: props.receiptGroup,
            matchMode: 'equals',
          },
        };

        if (props.receiptType) {
          _lazyParams.filters.receiptType = {
            value: props.receiptType,
            matchMode: 'equals',
          };
        }
      } else if (window.App.state.lazyparamsReceiptList) {
        let state = window.App.state.lazyparamsReceiptList;
        let filters = {
          ...state.filters,
          ...lazyParams.filters,
        };
        // if (props.receiptType) {
        //   filters.receiptType = {
        //     value: props.receiptType,
        //     matchMode: 'equals',
        //   };
        // }
        _lazyParams.filters = filters;

        Object.entries(window.App.state.lazyparamsReceiptList.filters).map(function (filter, index) {
          if (document.getElementById(filter[0])) {
            document.getElementById(filter[0]).value = filter[1].value;
          }
          if (filter[0] === 'isPaid') {
            setFilterPaid(filter[1].value);
          }
          if (filter[0] === 'outgoing') {
            setFilterIncome(filter[1].value);
          }
          if (filter[0] === 'allowed') {
            setFilterAllowed(filter[1].value);
          }
          if (filter[0] === 'receiptType') {
            setSelectedReceiptType(filter[1].value);
          }
        });
      } else {
        if (props.receiptType) {
          _lazyParams.filters = {
            ...(lazyParams.filters || {}),
            receiptType: {
              value: props.receiptType,
              matchMode: 'equals',
            }
          };
        }
      }
      let finalDetailedQuery = detailedSearchQuery || '';
        if (props.receiptGroup) {
          finalDetailedQuery = finalDetailedQuery
            .split('&')
            .filter(part =>
              !part.startsWith('search[receipt_group][operator]') &&
              !part.startsWith('search[receipt_group][value]') &&
              !part.startsWith('search[receiptGroup][operator]') &&
              !part.startsWith('search[receiptGroup][value]')
            )
            .join('&');
        }
        if (props.projectRetentionSearchQuery) {
          finalDetailedQuery = finalDetailedQuery
            .split('&')
            .filter(part =>
              !part.startsWith('search[receipt_type][operator]') &&
              !part.startsWith('search[receipt_type][value]')
            )
            .join('&');

          finalDetailedQuery = finalDetailedQuery
            ? `${finalDetailedQuery}&${props.projectRetentionSearchQuery}`
            : props.projectRetentionSearchQuery;
        }
      _lazyParams.detailedSearchQuery = finalDetailedQuery;

        fetchReceiptList(_lazyParams)
          .then(response => {
            const data = response.data?.data || {};
            const items = Array.isArray(data.items) ? data.items : [];
            setTotalRecords(data.total_item_count || 0);
            setReceipt(items);
            persistListState(_lazyParams);
            setLoading(false);

            let currencies = [...new Set(items.map(item => item.currency))];
            let tot = [];
            currencies.forEach((currency) => {
              if (!currency) return;
              let netSumByCurrency = 0;
              let vatSumByCurrency = 0;
              let brSumByCurrency = 0;

              items.forEach((receipt) => {
                if (receipt.currency == currency) {
                  netSumByCurrency += (Number(receipt.net_amount) || 0);
                  vatSumByCurrency += (Number(receipt.vat_amount) || 0);
                  brSumByCurrency += (Number(receipt.gross_amount) || 0);
                }
              });
              tot.push([{
                currency: currency,
                sumNet: netSumByCurrency,
                sumVat: vatSumByCurrency,
                sumBr: brSumByCurrency
              }]);
            });
            setSum(tot);
          })
          .catch(error => {
            safeToastShow('error', 'Hiba történt!', error.toString());
            setLoading(false);
          });

    }, Math.random() * 1000 + 250);
  }

  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
          {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    const canStorno = rowData.draft === false &&
      rowData.external === false &&
      ['CUSTOMER_INVOICE', 'CUSTOMER_ADVANCE_INVOICE'].includes(rowData.receipt_type) &&
      rowData.storno !== true &&
      !rowData.reversed_receipt &&
      !rowData.storno_receipt;
    const canDeleteFinalizedProforma = rowData.draft === false &&
      rowData.external === false &&
      rowData.receipt_type === 'CUSTOMER_PROFORMA';

    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_receipt_write') &&
          props.view !== 'purchaseorder' &&
          <>
            {rowData.draft === true ? (
              <>
                <Button icon="pi pi-pencil" className=" p-button-warning p-mr-2"
                        tooltip={t('edit')} tooltipOptions={{ position: 'left' }}
                        onClick={() => {
                          window.App.setState({
                            sidebarReceiptUpdate: true,
                            props: {
                            ...rowData,
                            receiptgroupId:
                            (props.receiptGroup && (props.receiptGroup.id || props.receiptGroup)) ||
                            (window.App.state.props && (window.App.state.props.receiptgroupId || window.App.state.props.receiptGroupId)) ||
                            (rowData.receipt_group && (rowData.receipt_group.id || rowData.receipt_group)) ||
                            rowData.receipt_group_id ||
                            null
                            }
                          })
                        }}/>
                <Button type="button"
                        tooltip={t('delete')} tooltipOptions={{ position: 'left' }}
                        onClick={() => {
                          if (window.confirm('A törlés megerősítésére van szükség!')) {
                            setLoading(true)
                            axios.delete(process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + rowData.id, {
                              headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
                            })
                              .then(response => {
                                safeToastShow('success', 'Sikeres törlés!', '');
                                window.App.setState({
                                  rerenderReceiptList: true,
                                  sidebarReceiptUpdate: false,
                                  sidebarReceiptCreate: false,
                                  sidebarReceiptShow: false,
                                })
                                setLoading(false)
                              })
                              .catch(error => {
                                safeToastShow('error', 'Hiba történt!', error.toString());
                                setLoading(false)
                              })
                          }
                        }}
                        loading={loading}
                        icon={"pi pi-trash"}
                        className=" p-button-danger p-mr-2"/>
              </>
            ) : (
              <>
                <Button icon="pi pi-pencil" className=" p-button-warning p-mr-2 disabled"
                        tooltip={t('edit')} tooltipOptions={{ position: 'left' }}/>
                {['CUSTOMER_INVOICE', 'CUSTOMER_ADVANCE_INVOICE'].includes(rowData.receipt_type) &&
                  <>
                    {canStorno ? (
                      <Button type="button"
                              tooltip={t('storno')} tooltipOptions={{ position: 'left' }}
                              onClick={() => {
                                if (window.confirm('Biztosan létrehozod a bizonylatot érvénytelenítő sztornóbizonylatot?')) {
                                  setLoading(true)
                                  axios.post(process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + rowData.id + "/storno", {}, {
                                    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
                                  })
                                    .then(response => {
                                      safeToastShow('success', 'Sikeres sztornózás!', '');
                                      window.App.setState({
                                        rerenderReceiptList: true,
                                        sidebarReceiptUpdate: false,
                                        sidebarReceiptCreate: false,
                                        sidebarReceiptShow: false,
                                      })
                                      setLoading(false)
                                      const stornoReceipt = response.data?.data;
                                      if (stornoReceipt?.id) {
                                        history.push(`/finance/receipt/read/${stornoReceipt.id}`);
                                      }
                                    })
                                    .catch(error => {
                                      safeToastShow('error', 'Hiba történt!', error.toString());
                                      setLoading(false)
                                    })
                                }
                              }}
                              loading={loading}
                              icon={"pi pi-replay"}
                              className=" p-button-danger p-mr-2"/>
                    ) : (
                      <Button type="button"
                              tooltip={t('storno')} tooltipOptions={{ position: 'left' }}
                              loading={loading}
                              disabled
                              icon={"pi pi-replay"}
                              className=" p-button-danger p-mr-2"/>
                    )}
                  </>
                }
                {canDeleteFinalizedProforma &&
                  <>
                    <Button type="button"
                            tooltip={t('delete')} tooltipOptions={{ position: 'left' }}
                            onClick={() => {
                              if (window.confirm('A törlés megerősítésére van szükség!')) {
                                setLoading(true)
                                axios.delete(process.env.REACT_APP_API_HOST + "/api/v2/receipt/" + rowData.id, {
                                  headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
                                })
                                  .then(response => {
                                    safeToastShow('success', 'Sikeres törlés!', '');
                                    window.App.setState({
                                      rerenderReceiptList: true,
                                      sidebarReceiptUpdate: false,
                                      sidebarReceiptCreate: false,
                                      sidebarReceiptShow: false,
                                    })
                                    setLoading(false)
                                  })
                                  .catch(error => {
                                    safeToastShow('error', 'Hiba történt!', error.toString());
                                    setLoading(false)
                                  })
                              }
                            }}
                            loading={loading}
                            icon={"pi pi-trash"}
                            className=" p-button-danger p-mr-2"/>
                  </>
                }
              </>
            )}
          </>
        }
        <Button icon="pi pi-eye" className=" p-button p-mr-2"
                tooltip={t('view')} tooltipOptions={{ position: 'left' }}
                onClick={() => {
                  history.push('/finance/receipt/read/' + rowData.id,
                    {
                      from: history.location.pathname + history.location.search
                    }
                  )
                }}/>
        {!(props.receiptType && props.receiptType.toString().startsWith('SUPPLIER_')) && (
          <>
            {(rowData.receipt_type && rowData.receipt_type.includes('CUSTOMER')) ? (
              <Button icon="pi pi-download" className="p-button-secondary p-mr-2"
                      tooltip={t('download')} tooltipOptions={{ position: 'left' }}
                      onClick={() => {
                        setLoading(true)
                        fetchReceiptDownloadPdfService(rowData.id)
                          .then(response => {
                            safeToastShow('success', 'Sikeres letöltés!', '');
                            setLoading(false)
                            download(response.data, localStorage.getItem('networkName')
                              + '_'
                              + 'bizonylat'
                              + '_'
                              + rowData.receipt_number
                              + '.pdf')
                          })
                          .catch(error => {
                            safeToastShow('error', 'Hiba történt!', error.toString());
                            setLoading(false)
                          })
                      }}/>
            ) : (
              <>
                <Button icon="pi pi-download" className="  p-mr-2 disabled"
                        tooltip={t('download')}
                />
              </>
            )}
          </>
        )}
        
        {!(props.receiptType && props.receiptType.toString().startsWith('SUPPLIER_')) && (
          <>
            {rowData.receipt_type?.startsWith('CUSTOMER_')
            && rowData.external === false
            && rowData.draft === false ? (
              <Button icon="pi pi-envelope" className=" p-mr-2 p-button-info"
                      tooltip={t('invoiceEmailDelivery')} tooltipOptions={{ position: 'left' }}
                      onClick={() => {
                        window.App.setState({
                          dialogReceiptSend: true,
                          props: rowData
                        })
                      }}/>
            ) : (
              <Button icon="pi pi-envelope" className=" p-mr-2 p-button-info disabled"
                      tooltip={t('invoiceEmailDelivery')} tooltipOptions={{ position: 'left' }}
              />
            )}
          </>
        )}
      </React.Fragment>
    );
  }

  const renderCurrencyTotals = (totalsMap) => {
    if (!totalsMap || totalsMap.size === 0) return null;
    const priority = ['HUF', 'EUR'];
    const entries = Array.from(totalsMap.entries()).sort(([a], [b]) => {
      const ai = priority.indexOf(a);
      const bi = priority.indexOf(b);
      if (ai !== -1 && bi !== -1) return ai - bi;
      if (ai !== -1) return -1;
      if (bi !== -1) return 1;
      return String(a).localeCompare(String(b));
    });
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-end' }}>
        {entries.map(([currency, sum]) => (
          <div key={currency} style={{ whiteSpace: 'nowrap' }}>
            {(window?.App?.currencyFormatter
              ? window.App.currencyFormatter(currency, sum)
              : `${sum} ${currency}`)}
          </div>
        ))}
      </div>
    );
  };

  const getReceiptTypeLabel = (receiptType) => {
    const found = (receipttypes || []).find(item => item.id === receiptType);
    return found ? found.name : (receiptType || '-');
  };

  const currencyPriority = ['HUF', 'EUR'];

  const sortCurrencies = (a, b) => {
    const ai = currencyPriority.indexOf(a);
    const bi = currencyPriority.indexOf(b);
    if (ai !== -1 && bi !== -1) return ai - bi;
    if (ai !== -1) return -1;
    if (bi !== -1) return 1;
    return String(a).localeCompare(String(b));
  };

  const buildTotalsByReceiptTypeAndCurrency = (amountField) => {
    const map = new Map();
    (receipt || []).forEach(row => {
      const receiptType = row?.receipt_type || '-';
      const currency = row?.currency || process.env.REACT_APP_CURRENCY_DEFAULT || 'HUF';
      const amount = Number(row?.[amountField]);
      if (!Number.isFinite(amount)) return;
      if (!map.has(receiptType)) {
        map.set(receiptType, new Map());
      }
      const currencyMap = map.get(receiptType);
      currencyMap.set(currency, (currencyMap.get(currency) || 0) + amount);
    });
    return map;
  };

  const renderReceiptTypeCurrencyTotals = (totalsMap) => {
    if (!totalsMap || totalsMap.size === 0) return null;
    const entries = Array.from(totalsMap.entries()).sort(([typeA], [typeB]) => {
      return getReceiptTypeLabel(typeA).localeCompare(getReceiptTypeLabel(typeB));
    });
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-end' }}>
        {entries.map(([receiptType, currencyMap]) => {
          const currencyEntries = Array.from(currencyMap.entries()).sort(([a], [b]) => sortCurrencies(a, b));
          return (
            <div key={receiptType} style={{ textAlign: 'right' }}>
              <div style={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}>
                {getReceiptTypeLabel(receiptType)}
              </div>
              {currencyEntries.map(([currency, sum]) => (
                <div key={`${receiptType}-${currency}`} style={{ whiteSpace: 'nowrap' }}>
                  {window?.App?.currencyFormatter
                    ? window.App.currencyFormatter(currency, sum)
                    : `${sum} ${currency}`}
                </div>
              ))}
            </div>
          );
        })}
      </div>
    );
  };

  const totalsByNetAmount = React.useMemo(() => {
    return buildTotalsByReceiptTypeAndCurrency('net_amount');
  }, [receipt, receipttypes]);

  const totalsByGrossAmount = React.useMemo(() => {
    return buildTotalsByReceiptTypeAndCurrency('gross_amount');
  }, [receipt, receipttypes]);

  const netFooter = React.useMemo(() => {
    return renderReceiptTypeCurrencyTotals(totalsByNetAmount);
  }, [totalsByNetAmount, receipttypes]);

  const grossFooter = React.useMemo(() => {
    return renderReceiptTypeCurrencyTotals(totalsByGrossAmount);
  }, [totalsByGrossAmount, receipttypes]);

  const receiptTypeBodyTemplate = (rowData) => {
    if (rowData.storno === true || rowData.reversed_receipt) {
      return <>{t('stornoInvoice')}</>;
    }
    if (rowData.storno_receipt) {
      return <>{t('stornedInvoice')}</>;
    }
    if (rowData.receipt_group && rowData.receipt_group.name) {
      return <>{rowData.receipt_group.name}</>;
    }

    const receiptType = (receipttypes || []).find(item => item.id === rowData.receipt_type);
    return receiptType ? receiptType.name : rowData.receipt_type;
  };

  const receiptTypeOptions = (receipttypes || []).map(type => ({
    label: type.name,
    value: type.id
  }));

  const generateReceiptGroupsMenu = (receiptgroups) => {
    return (receiptgroups || [])
      .filter(group => group.active === true)
      .map(group => ({
        label: group.name,
        command: () => {
          let sidebarStateKey = 'sidebarReceiptInvoiceCreate';
          if (group.receipt_type === 'cost' || (group.receipt_type === 'invoice' && group.external === true)) {
             sidebarStateKey = 'sidebarReceiptCostCreate';
          } else if (group.receipt_type === 'fee_request') {
             sidebarStateKey = 'sidebarReceiptFeeRequestCreate';
          } else if (group.receipt_type === 'delivery_note') {
             sidebarStateKey = 'sidebarReceiptDeliveryNoteCreate';
          }
          window.App.setState({
            [sidebarStateKey]: true,
            props: {
              receiptType: group.receipt_type,
              receiptgroupId: group.id,
              external: group.external,
              outgoing: group.receipt_type.includes('CUSTOMER'),
              name: group.name,
              operation: group.external ? t('recordSuffix') : t('createSuffix')
            }
          });
        }
      }));
  };

  let columns = [{}]
  if (props.view === 'advanced') {
    columns = [
      {
        field: 'delivery_date',
        header: 'Teljesítés',
        sortable: 'true',
        filter: 'true',
        body: (rowData) => {
          return <>{window.App.formatDateValue(rowData.delivery_date)}</>
        },
      },
      {
        field: 'payment_date',
        header: 'Fizetési határidő',
        sortable: 'true',
        filter: 'true',
        body: (rowData) => {
          return <>{window.App.formatDateValue(rowData.payment_date)}</>
        },
      },
      {
        field: 'next_payment_date',
        header: 'Következő kifizetés',
        sortable: 'true',
        filter: 'true',
        body: (rowData) => {
          return <>{rowData.next_payment_date ? window.App.formatDateValue(rowData.next_payment_date) : ''}</>
        },
      },
    ];
  }
  const [selectedColumns, setSelectedColumns] = useState(columns);
  const [selectedColumnsCut, setSelectedColumnsCut] = useState();
  const [columnsCut, setColumnsCut] = useState([]);
  const onColumnToggle = (event) => {
    let selectedColumns = event.value;
    let orderedSelectedColumns = columns.filter(col => selectedColumns.some(sCol => sCol.field === col.field));
    let orderedSelectedColumnsCut = []
    orderedSelectedColumns.map((item) => {
      orderedSelectedColumnsCut.push({
        field: item.field,
        header: item.header
      })
    })
    setSelectedColumns(orderedSelectedColumns);
    setSelectedColumnsCut(orderedSelectedColumnsCut)
    localStorage.removeItem("colsReceiptList")
    localStorage.setItem("colsReceiptList", JSON.stringify(orderedSelectedColumnsCut))
  }
  const columnComponents = selectedColumns.map(col => {
    return <Column key={col.field}
                   field={col.field}
                   header={col.header}
                   sortable={col.sortable}
                   body={col.body}
                   className={col.className}/>;
  });

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');

  

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState();

  const searchProject = (event) => {
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/project?search[name]=" + event.query, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      }
    })
    .then(response => {
      setProjects(response.data.data.items)
    })
    .catch(error => {
      safeToastShow('error', 'Hiba történt!', error.toString());
    })
  }

  const [costtypes, setCosttypes] = useState([]);
  const [selectedCosttype, setSelectedCosttype] = useState('');

  const searchCosttype = (event) => {
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/cost-type?search[name]=" + event.query, {
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
      }
    })
    .then(response => {
      setCosttypes(response.data.data.items)
    })
    .catch(error => {
      safeToastShow('error', 'Hiba történt!', error.toString());
      })
  }

  const searchHeaderTemplate = (options) => {
    const toggleIcon = options.collapsed ? 'pi pi-chevron-down' : 'pi pi-chevron-up';
    return (
      <>
        <div className={"p-grid"}>
          <div className={"p-col-12 p-lg-6 p-col-align-center"}>
            <h3 className={"p-p-0 p-m-0"}>
              <button className={options.togglerClassName} onClick={options.onTogglerClick}>
                <span className={toggleIcon}></span>
              </button>
              &nbsp; Szűrés
            </h3>
          </div>
          <div className={"p-col-12 p-lg-6 p-text-right p-col-align-center"}>
            <Button className={"p-button-danger p-mr-2 p-text-light"}
                    label={t('dsClearFilter')} icon="pi pi-times"
                    onClick={() => {
                      setFilterSupplierName('')
                      setDsPartner('');
                      setFilterCustomerName('')
                      setFilterNetAmountMin('')
                      setFilterNetAmountMax('')
                      setFilterIssueDateFrom('')
                      setFilterIssueDateTo('')
                      setFilterDeliveryDateFrom('')
                      setFilterDeliveryDateTo('')
                      setFilterPaymentDateFrom('')
                      setFilterPaymentDateTo('')
                      setFilterRetentionPaymentDateFrom('')
                      setFilterRetentionPaymentDateUntil('')
                      setFilterPaidDateFrom('')
                      setFilterPaidDateTo('')
                      setFilterReceiptNumber('')
                      setFilterAllowed(null)
                      setFilterPaid(null)
                      setFilterIncome(null)
                      setSelectedPaymentMethod('')
                      setSelectedProject('')
                      setSelectedCosttype('')
                      setSelectedReceiptType('')
                      setDsNetAmountMin(null);
                      setDsNetAmountMax(null);
                      setDsVatAmountMin(null);
                      setDsVatAmountMax(null);
                      setDsGrossAmountMin(null);
                      setDsGrossAmountMax(null);
                      setLazyParams({
                        first: 0,
                        rows: rows,
                        page: 0,
                        sortField: 'id',
                        sortOrder: 1,
                      })
                      if(window.App && window.App.setState) {
                        window.App.setState({
                            lazyparamsReceiptList: null
                        })
                      }
                    }}
            />
          </div>
        </div>
      </>
    )
  }

  useEffect(() => {
    if (props.receiptGroup) {
      setDsReceiptGroup(props.receiptGroup);
    }
  }, [props.receiptGroup]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(DS_STORAGE_KEY);
      if (!raw) return;
      const s = JSON.parse(raw);

      setDsPartner(s.dsPartner ?? '');
      setDsReceiptNumber(s.dsReceiptNumber ?? '');
      setDsReceiptGroup(s.dsReceiptGroup ?? null);
      setDsReceiptType(s.dsReceiptType ?? null);
      setDsCurrency(s.dsCurrency ?? null);
      setDsCostCenter(s.dsCostCenter ?? null);
      setDsCostType(s.dsCostType ?? null);

      setDsIsPaid(s.dsIsPaid ?? null);
      setDsDraft(s.dsDraft ?? null);
      setDsStorno(s.dsStorno ?? null);
      setDsCostPosted(s.dsCostPosted ?? null);

      setDsIssueDateFrom(s.dsIssueDateFrom ?? null);
      setDsIssueDateTo(s.dsIssueDateTo ?? null);
      setDsPaymentDateFrom(s.dsPaymentDateFrom ?? null);
      setDsPaymentDateTo(s.dsPaymentDateTo ?? null);
      setDsDeliveredDateFrom(s.dsDeliveredDateFrom ?? null);
      setDsDeliveredDateTo(s.dsDeliveredDateTo ?? null);

      setDsNetAmountMin(s.dsNetAmountMin ?? null);
      setDsNetAmountMax(s.dsNetAmountMax ?? null);
      setDsVatAmountMin(s.dsVatAmountMin ?? null);
      setDsVatAmountMax(s.dsVatAmountMax ?? null);
      setDsGrossAmountMin(s.dsGrossAmountMin ?? null);
      setDsGrossAmountMax(s.dsGrossAmountMax ?? null);

      if ((saved?.detailedSearchQuery || '').trim()) {
        setDetailedSearchVisible(true);
        loadFilterOptions();
      }
    } catch (error) {
      safeToastShow('error', 'Hiba történt!', error.toString());
    }
  }, []);

  useEffect(() => {
    fetchReceiptGroupList({
        first: 0,
        rows: 9999,
        page: 0,
      })
      .then(response => {
        const data = response.data?.data;
        const items = data?.items || (Array.isArray(data) ? data : []);
        setReceiptgroups(items);
      })
      .catch(error => {
        safeToastShow('error', 'Hiba történt!', error.toString());
      });
    axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/dictionary/receipt-type",
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const raw = response?.data?.data || [];
        const types = raw.map(item => ({
          id: item.key,
          name: item.value
        }));
        setReceipttypes(types);
      })
      .catch(error => {
        safeToastShow('error', 'Hiba történt!', error.toString());
      });

    let columnsCut = [];
    columns.map((item) => {
      columnsCut.push({
        field: item.field,
        header: item.header
      });
    });
    setColumnsCut(columnsCut);
    let colsReceiptList = JSON.parse(localStorage.getItem("colsReceiptList"));
    if (colsReceiptList && colsReceiptList[0] && colsReceiptList[0].field) {
      setSelectedColumnsCut(colsReceiptList);
      let orderedSelectedColumns = columns.filter(col =>
        colsReceiptList.some(sCol => sCol.field === col.field)
      );
      setSelectedColumns(orderedSelectedColumns);
    } else {
      let orderedSelectedColumnsCut = [];
      columns.map((item) => {
        orderedSelectedColumnsCut.push({
          field: item.field,
          header: item.header
        });
      });
      setSelectedColumnsCut(orderedSelectedColumnsCut);
    }
  }, []);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, props.receiptGroup, props.receiptType, window.App.state.rerenderReceiptList === true]);

  useEffect(() => {
    if (typeof onDetailedSearchActiveChange === 'function') {
      onDetailedSearchActiveChange(isDetailedSearchActive);
    }
  }, [isDetailedSearchActive, onDetailedSearchActiveChange]);


  return (
    <>
      {props && props.view === 'advanced' &&
        <>
          <h2 className={"text-primary"}>
            {window.App.state.headerReceiptList ? (
              <>{window.App.state.headerReceiptList}</>
            ) : (
              <>{props.t('receiptList')}</>
            )}
          </h2>
          <Panel headerTemplate={searchHeaderTemplate} toggleable collapsed={searchCollapsed}
                 onToggle={(e) => setSearchCollapsed(e.value)}
                 className={"p-pb-2"}
                 id={"filters"}
          >
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('columnCompany')}</label>
                  <span className={"p-d-block"}>
                <InputText id="companyName"
                           onChange={(e) => {
                             setFilterSupplierName(e.target.value)
                             let value = e.target.value
                             clearTimeout(window.searchTimeout)
                             window.searchTimeout = setTimeout(function () {
                               dt.current.filter(value, 'company_name', ''); 
                             }, 500)
                           }}
                           value={filterSupplierName}
                />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('columnPartner')}</label>
                  <span className={"p-d-block"}>
                <InputText id="partnerName"
                           onChange={(e) => {
                             setFilterCustomerName(e.target.value)
                             let value = e.target.value
                             clearTimeout(window.searchTimeout)
                             window.searchTimeout = setTimeout(function () {
                               dt.current.filter(value, 'partner_name', '');
                             }, 500)
                           }}
                           value={filterCustomerName}
                />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-1"}>
                <div className="p-field p-fluid">
                  <label>{t('fieldMinNetAmount')}</label>
                  <span className={"p-d-block"}>
                <InputNumber id="netAmountMin"
                             locale="hu-HU"
                             minFractionDigits={0}
                             maxFractionDigits={9}
                             onChange={(e) => {
                               setFilterNetAmountMin(e.value)
                               clearTimeout(window.searchTimeout)
                               window.searchTimeout = setTimeout(function () {
                                 dt.current.filter(e.value, 'netAmountMin', '');
                               }, 500)
                             }}
                             value={filterNetAmountMin}
                />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-1"}>
                <div className="p-field p-fluid">
                  <label>{t('fieldMaxNetAmount')}</label>
                  <span className={"p-d-block"}>
                <InputNumber id="netAmountMax"
                             locale="hu-HU"
                             minFractionDigits={0}
                             maxFractionDigits={9}
                             onChange={(e) => {
                               setFilterNetAmountMax(e.value)
                               clearTimeout(window.searchTimeout)
                               window.searchTimeout = setTimeout(function () {
                                 dt.current.filter(e.value, 'netAmountMax', '');
                               }, 500)
                             }}
                             value={filterNetAmountMax}
                />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('columnIssueDate')}</label>
                  <div className={"p-grid"}>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"issueDateFrom"}
                               value={filterIssueDateFrom}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterIssueDateFrom(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'issueDateFrom', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                    <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
                      <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
                    </div>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"issueDateTo"}
                               value={filterIssueDateTo}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterIssueDateTo(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'issueDateTo', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('columnFulfillment')}</label>
                  <div className={"p-grid"}>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"deliveryDateFrom"}
                               value={filterDeliveryDateFrom}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterDeliveryDateFrom(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'deliveryDateFrom', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                    <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
                      <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
                    </div>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"deliveryDateTo"}
                               value={filterDeliveryDateTo}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterDeliveryDateTo(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'deliveryDateTo', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('columnPaymentDeadline')}</label>
                  <div className={"p-grid"}>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"paymentDateFrom"}
                               value={filterPaymentDateFrom}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterPaymentDateFrom(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'paymentDateFrom', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                    <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
                      <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
                    </div>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"paymentDateTo"}
                               value={filterPaymentDateTo}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterPaymentDateTo(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'paymentDateTo', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('fieldRetentionDeadline')}</label>
                  <div className={"p-grid"}>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"retentionPaymentDateFrom"}
                               value={filterRetentionPaymentDateFrom}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterRetentionPaymentDateFrom(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'retentionPaymentDateFrom', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                    <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
                      <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
                    </div>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"retentionPaymentDateUntil"}
                               value={filterRetentionPaymentDateUntil}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterRetentionPaymentDateUntil(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'retentionPaymentDateUntil', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>
                    Fizetve dátum
                  </label>
                  <div className={"p-grid"}>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"paidDateFrom"}
                               value={filterPaidDateFrom}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterPaidDateFrom(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'paidDateFrom', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                    <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
                      <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
                    </div>
                    <div className={"p-col-5"}>
                  <span className={"p-d-block"}>
                    <InputMask id={"paidDateTo"}
                               value={filterPaidDateTo}
                               mask={"9999-99-99"}
                               placeholder={t('datePlaceholder')}
                               onChange={(e) => {
                                 if (e.value.indexOf("_") === -1) {
                                   if (e.value === '') {
                                     e.value = null
                                   }
                                   setFilterPaidDateTo(e.value)
                                   clearTimeout(window.searchTimeout)
                                   window.searchTimeout = setTimeout(function () {
                                     dt.current.filter(e.value, 'paidDateTo', '');
                                   }, 500)
                                 }
                               }}
                    />
                  </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('fieldInvoiceNumber')}</label>
                  <span className={"p-d-block"}>
                <InputText id="receiptNumber"
                           onChange={(e) => {
                             setFilterReceiptNumber(e.target.value)
                             let value = e.target.value
                             clearTimeout(window.searchTimeout)
                             window.searchTimeout = setTimeout(function () {
                               dt.current.filter(value, 'receipt_number', '');
                             }, 500)
                           }}
                           value={filterReceiptNumber}
                />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('project')}</label>
                  <span className={"p-d-block"}>
                <AutoComplete value={selectedProject}
                              id={"project"}
                              suggestions={projects}
                              completeMethod={searchProject}
                              field={"name"}
                              delay="1000"
                              forceSelection
                              dropdown
                              placeholder={t('typeToSearchPlaceholder')}
                              onSelect={(e) => {
                                dt.current.filter(e.value.id, 'project', '');
                                setSelectedProject(e.value.name)
                              }}
                              onClear={(e) => {
                                setSelectedProject('')
                                dt.current.filter(null, 'project', '');
                              }}
                />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('columnCostType')}</label>
                  <span className={"p-d-block"}>
                <AutoComplete value={selectedCosttype}
                              id={"costType"}
                              suggestions={costtypes}
                              forceSelection
                              completeMethod={searchCosttype}
                              field={"name"}
                              delay="1000"
                              placeholder={t('typeToSearchPlaceholder')}
                              onSelect={(e) => {
                                dt.current.filter(e.value.id, 'costType', '');
                                setSelectedCosttype(e.value.name)
                              }}
                              dropdown
                              onClear={(e) => {
                                setSelectedCosttype('')
                                dt.current.filter(null, 'costType', '');
                              }}
                />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('fieldDocumentType')}</label>
                  <span className={"p-d-block"}>
                  <Dropdown options={receiptTypeOptions}
                            optionLabel="label"
                            optionValue="value"
                            id={"receiptType"}
                            emptyMessage={t('noType')}
                            onChange={(e) => {
                              setSelectedReceiptType(e.value)
                              dt.current.filter(e.value, 'receiptType', '');
                            }}
                            showClear
                            value={selectedReceiptType}
                  />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-2 p-xl-2"}>
                <div className="p-field p-fluid">
                  <label>{t('columnPartnerType')}</label>
                  <span className={"p-d-block"}>
                  <Dropdown options={[
                    {
                      name: t('person'),
                      id: "person"
                    },
                    {
                      name: t('organisation'),
                      id: "organisation"
                    },
                    {
                      name: t('other'),
                      id: "other"
                    },
                  ]}
                            optionLabel="name"
                            optionValue="id"
                            id={"partnerType"}
                            emptyMessage={t('noTypeYet')}
                            onChange={(e) => {
                              setSelectedPartnerType(e.value)
                              dt.current.filter(e.value, 'partnerType', '');
                            }}
                            showClear
                            value={selectedPartnerType}
                  />
              </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-10 p-pt-5"}>
                <div className="p-fluid p-py-1 p-mt-2">
                  <label className={"p-mr-2"}>
                    <TriStateCheckbox inputId="outgoing" id="outgoing" value={filterIncome}
                                      onChange={e => {
                                        dt.current.filter(e.value, 'outgoing', '');
                                        setFilterIncome(e.value)
                                      }}/>
                    &nbsp;
                    Kimenő
                  </label>
                  <label className={"p-mr-2"}>
                    <TriStateCheckbox inputId="isPaid" id="isPaid" value={filterPaid}
                                      onChange={e => {
                                        dt.current.filter(e.value, 'isPaid', '');
                                        setFilterPaid(e.value)
                                      }}/>
                    &nbsp;
                    Fizetve
                  </label>
                  <label className={"p-mr-2"}>
                    <TriStateCheckbox inputId="allowed" id="allowed"
                                      value={filterAllowed}
                                      onChange={e => {
                                        dt.current.filter(e.value, 'allowed', '');
                                        setFilterAllowed(e.value)
                                      }}/>
                    &nbsp;
                    Jóváhagyva
                  </label>
                </div>
              </div>
            </div>
          </Panel>
        </>
      }
      {props.view !== 'advanced' && props.view !== 'purchaseorder' &&
        <>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-3 p-col-align-center p-text-center p-text-lg-left"}>
              <h2 className={"p-m-0 p-p-0 text-primary p-d-inline"}>
                  {props.receiptGroupName
                  ? `${props.receiptGroupName}`
                  : props.t('receiptList')}
               </h2>
              {/* <Button className={"p-button-outlined p-button-danger  p-mr-2"}
                      label={t('dsClearFilter')} icon="pi pi-times"
                      style={{border: 'none'}}
                      onClick={() => {
                        setLazyParams({
                          first: 0,
                          rows: rows,
                          page: 0,
                          sortField: 'id',
                          sortOrder: 1,
                        })
                      }}
              />
              <Button className={"p-button-outlined  "}
                      style={{border: 'none'}}
                      label={t('extendedView')} icon="pi pi-window-maximize"
                      onClick={() => {
                        window.App.setState({
                          headerReceiptList: props.receiptGroupName,
                          lazyparamsReceiptList: {
                            first: 0,
                            rows: 10,
                            page: 0,
                            sortField: 'issueDate',
                            sortOrder: 1,
                            filters: {
                              receiptGroup: {value: props.receiptGroup},
                              ...(props.receiptType ? { receiptType: { value: props.receiptType } } : {}),
                            }
                          },
                          sidebarReceiptList: true
                        })
                      }}
              /> */}
            </div>
                        <div className={"p-col-12 p-lg-9 p-col-align-center p-text-center p-text-lg-right"}>
              <Button
                type="button"
                label={t('detailedSearch')}
                icon={isDetailedSearchActive ? "pi pi-filter-fill" : "pi pi-filter"}
                className="p-button-outlined p-mr-2"
                onClick={() => {
                  setDetailedSearchVisible(!detailedSearchVisible);
                  if (!detailedSearchVisible) {
                    loadFilterOptions();
                  }
                }}
              />

              {localStorage.getItem('roles').toString().includes('role_receipt_write') && !isPicker &&
                <SplitButton label={t('new')}
                             id="buttonAdd"
                             onClick={() => {
                               document.getElementById('buttonAdd').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                             }}
                             icon="pi pi-plus"
                             className={"p-button-success p-ml-md-2"}
                             model={generateReceiptGroupsMenu(receiptgroups)}/>
              }
            </div>
          </div>
        </>
      }
      {props.view !== 'advanced' && detailedSearchVisible &&
        <Panel className="p-mb-2" onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              if (document.activeElement) document.activeElement.blur();
              setTimeout(() => {
                const searchBtn = document.querySelector('button.p-button-primary .pi-search')?.parentElement;
                if (searchBtn) searchBtn.click();
              }, 100);
            }
          }}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnPartner')}</label>
                <InputText
                  value={dsPartner}
                  onChange={(e) => setDsPartner(e.target.value)}
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnSerialNumber')}</label>
                <InputText
                  value={dsReceiptNumber}
                  onChange={(e) => setDsReceiptNumber(e.target.value)}
                  placeholder={t('dsExampleSerialNumber')}
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('fieldReceiptGroup')}</label>
                <Dropdown
                  value={dsReceiptGroup}
                  // options={receipttypes}
                  options={(receiptgroups || []).map(g => ({ label: g.name, value: g.id }))}
                  onChange={(e) => setDsReceiptGroup(e.value)}
                  showClear
                  disabled={isFixedReceiptGroupList}
                  placeholder={t('dsSelect')}
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('fieldDocumentTypeFull')}</label>
                <Dropdown
                  value={dsReceiptType}
                  options={(receipttypes || []).map(rt => ({ label: rt.name, value: rt.id }))}
                  onChange={(e) => setDsReceiptType(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnCurrency')}</label>
                <Dropdown
                  value={dsCurrency}
                  options={[
                    { label: 'HUF', value: 'HUF' },
                    { label: 'EUR', value: 'EUR' },
                    { label: 'USD', value: 'USD' },
                    { label: 'GBP', value: 'GBP' },
                  ]}
                  onChange={(e) => setDsCurrency(e.value)}
                  showClear
                  placeholder={t('dsSelect')}
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnCostCenter')}</label>
                <TreeSelect
                  value={dsCostCenter ? String(dsCostCenter) : null}
                  filter
                  options={(costCenters)}
                  disabled={costCentersLoading}
                  placeholder={costCentersLoading ? t('dsLoading') : t('dsSelect')}
                  onChange={(e) => setDsCostCenter(e.value ? Number(e.value) : null)}
                  showClear
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnCostType')}</label>
                <Dropdown
                  value={dsCostType}
                  optionLabel='name'
                  filter
                  optionValue='id'
                  disabled={costTypesLoading}
                  options={(costTypes)}
                  placeholder={costTypesLoading ? t('dsLoading') : t('dsSelect')}
                  onShow={loadFilterOptions}
                  onChange={(e) => setDsCostType(e.value)}
                  showClear
                />
              </div>
            </div>
            <div className={"p-col-12 p-lg-11"}>
              <div className="p-field p-fluid">
                <label>&nbsp;</label>
                <div className="p-fluid p-py-1">
                  <label className={"p-mr-4"}>
                    <TriStateCheckbox
                      value={dsIsPaid}
                      onChange={(e) => setDsIsPaid(e.value)}
                    />
                    &nbsp;{t('fieldPaid')}
                  </label>
                  <label className={"p-mr-4"}>
                    <TriStateCheckbox
                      value={dsDraft}
                      onChange={(e) => setDsDraft(e.value)}
                    />
                    &nbsp;{t('draft')}
                  </label>
                  <label className={"p-mr-4"}>
                    <TriStateCheckbox
                      value={dsStorno}
                      onChange={(e) => setDsStorno(e.value)}
                    />
                    &nbsp;{t('dsStorno')}
                  </label>
                  <label className={"p-mr-4"}>
                    <TriStateCheckbox
                      value={dsCostPosted}
                      onChange={(e) => setDsCostPosted(e.value)}
                    />
                    &nbsp;{t('columnCostsRecorded')}
                  </label>
                </div>
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('fieldIssueDate')}</label>
                <div className={"p-grid"}>
                  <div className={"p-col-12"}>
                    <Calendar
                      value={parseCalendarRangeValue(dsIssueDateFrom, dsIssueDateTo)}
                      onChange={(e) =>
                        handleCalendarRangeChange(
                          e.value,
                          setDsIssueDateFrom,
                          setDsIssueDateTo,
                          'dsIssueDateFrom',
                          'dsIssueDateTo'
                        )
                      }
                      selectionMode="range"
                      readOnlyInput
                      showIcon
                      dateFormat="yy-mm-dd"
                      appendTo={document.body}
                      locale="hu"
                      placeholder={t('dsFromTo')}
                      className="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnPaymentDeadline')}</label>
                <div className={"p-grid"}>
                  <div className={"p-col-12"}>
                    <Calendar
                      value={parseCalendarRangeValue(dsPaymentDateFrom, dsPaymentDateTo)}
                      onChange={(e) =>
                        handleCalendarRangeChange(
                          e.value,
                          setDsPaymentDateFrom,
                          setDsPaymentDateTo,
                          'dsPaymentDateFrom',
                          'dsPaymentDateTo'
                        )
                      }
                      selectionMode="range"
                      readOnlyInput
                      showIcon
                      dateFormat="yy-mm-dd"
                      appendTo={document.body}
                      locale="hu"
                      placeholder={t('dsFromTo')}
                      className="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnFulfillment')}</label>
                <div className={"p-grid"}>
                  <div className={"p-col-12"}>
                    <Calendar
                      value={parseCalendarRangeValue(dsDeliveredDateFrom, dsDeliveredDateTo)}
                      onChange={(e) =>
                        handleCalendarRangeChange(
                          e.value,
                          setDsDeliveredDateFrom,
                          setDsDeliveredDateTo,
                          'dsDeliveredDateFrom',
                          'dsDeliveredDateTo'
                        )
                      }
                      selectionMode="range"
                      readOnlyInput
                      showIcon
                      dateFormat="yy-mm-dd"
                      appendTo={document.body}
                      locale="hu"
                      placeholder={t('dsFromTo')}
                      className="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnNetAmount')}</label>
                <div className={"p-grid"}>
                  <div className={"p-col-5"}>
                    <InputNumber value={dsNetAmountMin} onValueChange={(e) => setDsNetAmountMin(e.value)} placeholder={t('dsMin')}/>     
                  </div>
                  <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
                    <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
                  </div>
                  <div className={"p-col-5"}>
                    <InputNumber value={dsNetAmountMax} onValueChange={(e) => setDsNetAmountMax(e.value)} placeholder={t('dsMax')}/>
                  </div>
                </div>
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('fieldVatAmount')}</label>
                <div className={"p-grid"}>
                  <div className={"p-col-5"}>
                    <InputNumber value={dsVatAmountMin} onValueChange={(e) => setDsVatAmountMin(e.value)} placeholder={t('dsMin')}/>
                  </div>
                  <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
                    <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
                  </div>
                  <div className={"p-col-5"}>
                    <InputNumber value={dsVatAmountMax} onValueChange={(e) => setDsVatAmountMax(e.value)} placeholder={t('dsMax')}/>
                  </div>
                </div>
              </div>
            </div>
            <div className={"p-col-12 p-lg-2"}>
              <div className="p-field p-fluid">
                <label>{t('columnGrossAmount')}</label>
                <div className={"p-grid"}>
                  <div className={"p-col-5"}>
                    <InputNumber value={dsGrossAmountMin} onValueChange={(e) => setDsGrossAmountMin(e.value)} placeholder={t('dsMin')}/>
                  </div>
                  <div className={"p-col-2 p-text-center p-col-align-center p-px-0"}>
                    <i className={"pi pi-arrow-left"}></i> <i className={"pi pi-arrow-right"}></i>
                  </div>
                  <div className={"p-col-5"}>
                    <InputNumber value={dsGrossAmountMax} onValueChange={(e) => setDsGrossAmountMax(e.value)} placeholder={t('dsMax')}/>
                  </div>
                </div>
              </div>
            </div>
            <div className={"p-col-12 p-text-right"}>
              <Button
                type="button"
                label={t('dsClearCriteria')}
                icon="pi pi-times"
                className="p-button-danger p-mr-2"
                onClick={() => {
                  setDsReceiptGroup(null);
                  setDsPartner('');
                  setDsReceiptType(null);
                  setDsIssueDateFrom(null);
                  setDsIssueDateTo(null);
                  setDsPaymentDateFrom(null);
                  setDsPaymentDateTo(null);
                  setDsDeliveredDateFrom(null);
                  setDsDeliveredDateTo(null);
                  setDetailedSearchQuery('');
                  setDsReceiptNumber('');
                  setDsIsPaid(null);
                  setDsDraft(null);
                  setDsStorno(null);
                  setDsCostPosted(null);
                  setDsCurrency(null);
                  setDsCostCenter(null);
                  setDsCostType(null);
                  setDsNetAmountMax(null);
                  setDsNetAmountMin(null);
                  setDsVatAmountMax(null);
                  setDsVatAmountMin(null);
                  setDsGrossAmountMax(null);
                  setDsGrossAmountMin(null);
                  clearDetailedFormPersist();
                  setLazyParams({
                    first: 0,
                    rows: rows,
                    page: 0,
                    sortField: 'id',
                    sortOrder: 1,
                  });
                }}
              />
              <Button
                type="button"
                label={t('dsSearch')}
                icon="pi pi-search"
                className="p-button-primary"
                onClick={() => {
                  const q = buildDetailedSearchQuery();
                  setDetailedSearchQuery(q);
                  persistDetailedForm();
                  setLazyParams({
                    ...lazyParams,
                    first: 0,
                    page: 0,
                  });
                }}
              />
            </div>
          </div>
        </Panel>
      }
      <Panel>
      <DataTable size={localStorage.getItem('scale')}
        emptyMessage={t('noResults')}
        value={receipt} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows}
        autoLayout={true}
        ref={dt}
        filterDisplay="row"
        responsiveLayout="scroll"
        stripedRows
        selection={selectedReceipts}
        className={isPicker ? 'picker-table' : undefined}
        onRowDoubleClick={(e) => {
          if (isPicker) {
            goPick(e.data);
          }
        }}
        onSelectionChange={e => {
          if (!isPicker) setSelectedReceipts(e.value);
        }}
        dataKey="id"
        selectionMode={isPicker ? null : 'checkbox'}
      >
        {!isPicker && (
          <Column selectionMode="multiple" headerStyle={{width: '3em'}} />
        )}
        {!props.receiptGroup &&
          <Column field="receipt_type" header={t('columnType')} body={receiptTypeBodyTemplate}></Column>
        }
        {props.view === 'advanced' ? (
          <Column field="receipt_number" header={t('columnSerialNumber')} sortable body={(rowData) => {
            const severity = rowData?.draft ? 'warning' : 'success';
            return (
              <Badge
                value={rowData?.receipt_number}
                severity={severity}
              />
            );
          }}></Column>
        ) : (
          <Column field="receipt_number" header={t('columnSerialNumber')} sortable 
                  body={(rowData) => {
                    const severity = rowData?.draft ? 'warning' : 'success';
                      return (
                        <Badge
                          value={rowData?.receipt_number}
                          severity={severity}
                        />
                      );
                  }}></Column>
        )}
        {props.view === 'advanced' &&
          <Column field="company_name" header={t('columnCompany')} sortable></Column>
        }
        {props.view === 'advanced' ? (
          <Column header={t('columnPartner')} bodyClassName="col-body-font-bold" sortable body={(rowData) => rowData.partner?.name || rowData.partner_name || ''}></Column>
        ) : (
          <Column filterField="partner_name" bodyClassName="col-body-font-bold" header={t('columnPartner')} sortable  
          body={(rowData) => rowData.partner?.name || rowData.partner_name || ''}></Column>
        )}
        {props.view === 'advanced' &&
          <Column field="partnerType" header={t('columnPartnerType')} sortable body={(rowData) => {
            return (
              <>
                {rowData.partnerType === "person" &&
                  <>{t('person')}</>
                }
                {rowData.partnerType === "organisation" &&
                  <>{t('organisation')}</>
                }
                {rowData.partnerType === "other" &&
                  <>{t('other')}</>
                }
              </>
            )
          }}></Column>
        }
        <Column field="issue_date" header={t('columnIssueDate')} sortable className={"p-text-nowrap"} body={(rowData) => {
          return (
            <>
            {rowData.issue_date ? window.App.formatDateValue(rowData.issue_date) : ''}
            </>
          )
        }}></Column>
        <Column field="delivery_date" header={t('columnFulfillment')} sortable className={"p-text-nowrap"} body={(rowData) => {
          return (
            <>{window.App.formatDateValue(rowData.delivery_date)}</>
          )
        }}></Column>
        {!props.receiptGroup && (
          <Column field="payment_date" header={t('columnPaymentDeadline')} sortable className={"p-text-nowrap"} body={(rowData) => {
            return (
              <>{window.App.formatDateValue(rowData.payment_date)}</>
            )
          }}></Column>
        )}
        {columnComponents}
        {(props.receiptType && props.receiptType.toString().startsWith('SUPPLIER_')) && (
          <Column field="cost_posted" header={t('columnCostsRecorded')} sortable className={"p-text-center p-text-nowrap"}
                  body={(rowData) => {
                    if (rowData.cost_posted === true) {
                      return (
                        <>
                          <i className={"pi pi-check text-success"}></i>
                        </>
                      )
                    } else {
                      return (
                        <>
                          <i className={"pi pi-times text-danger"}></i>
                        </>
                      )
                    }
          }}></Column>
        )}
        <Column field="is_paid" header={t('columnPaid2')} sortable className={"p-text-center p-text-nowrap"}
                body={(rowData) => {
                  if (rowData.is_paid === true) {
                    return (
                      <>
                        <i className={"pi pi-check text-success"}></i>
                        {rowData.payment_date !== null && props.view === 'advanced' &&
                          <>
                            <br/>
                            {window.App.formatDateValue(rowData.payment_date)}
                          </>
                        }
                      </>
                    )
                  } else {
                    return (
                      <>
                        <i className={"pi pi-times text-danger"}></i>
                      </>
                    )
                  }
                }}></Column>
        {props.receiptType !== 'delivery_note' &&
          <Column
            field="net_amount"
            header={t('columnNetAmount')}
            sortable
            className={"p-text-right p-text-nowrap"}
            alignHeader="right"
            footer={netFooter}
            footerStyle={{ textAlign: 'right', fontWeight: 600 }}
            body={(rowData) => formatCurrency(rowData.currency, rowData.net_amount || 0)}
          />
        }
        {props.receiptType !== 'delivery_note' && props.view === 'advanced' &&
          <Column field="vat_amount" header={t('columnVatAmount')} sortable className={"p-text-right p-text-nowrap"}
                  alignHeader="right"
                  body={(rowData) => formatCurrency(rowData.currency, rowData.vat_amount || 0)}></Column>
        }
        {props.receiptType !== 'delivery_note' &&
          <Column
            field="gross_amount"
            header={t('columnGrossAmount')}
            sortable
            className={"p-text-right p-text-nowrap"}
            alignHeader="right"
            footer={grossFooter}
            footerStyle={{ textAlign: 'right', fontWeight: 600 }}
            body={(rowData) => formatCurrency(rowData.currency, rowData.gross_amount || 0)}
          />
        }
        {process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true' && props.receiptGroup && !(props.receiptType && props.receiptType.toString().startsWith('SUPPLIER_')) &&
          <Column field="nav_online_status" header={t('columnNavDataReporting')} sortable filter className={"p-text-nowrap"}
                  body={(rowData) => {
                    return (
                      <>
                        {rowData.nav_online_status === 'PROCESSING' &&
                          <>
                            <span className={"text-warning"}><i className={"pi pi-exclamation-circle"}></i> Feldolgozás folyamatban</span>
                          </>
                        }
                        {rowData.nav_online_status === 'RECEIVED' &&
                          <>
                            <span className={"text-warning"}><i className={"pi pi-exclamation-circle"}></i> Információk átadva</span>
                          </>
                        }
                        {rowData.nav_online_status === 'SAVED' &&
                          <>
                            <span className={"text-success"}><i
                              className={"pi pi-check"}></i> Információk rögzítve</span>
                          </>
                        }
                        {rowData.nav_online_status === 'ABORTED' &&
                          <>
                            <span className={"text-danger"}><i className={"pi pi-times"}></i> Megszakítva</span>
                          </>
                        }
                        {rowData.nav_online_status === 'DONE' &&
                          <>
                            <span className={"text-success"}><i className={"pi pi-check"}></i> Sikeres</span>
                          </>
                        }
                        {rowData.nav_online_status === 'WAITING' &&
                          <>
                            <span className={"text-warning"}><i className={"pi pi-refresh"}></i> Folyamatban</span>
                          </>
                        }
                        {rowData.nav_online_status === null &&
                          <>
                            {rowData.is_nav_invoice === false &&
                              <>
                                <span className={"disabled"}><i className={"pi pi-times"}></i> Nem lejelentendő</span>
                              </>
                            }
                            {rowData.is_nav_invoice === true &&
                              <>
                                <span><i className={"pi pi-times"}></i> Nincs adat</span>
                              </>
                            }
                          </>
                        }
                      </>
                    )
                  }}
                  filterElement={() => {
                    return (
                      <>
                        {lazyParams && lazyParams.filters && lazyParams.filters.navOnlineStatus ? (
                          <Dropdown options={[
                            {
                              value: "processing",
                              name: "Feldolgozása folyamatban"
                            },
                            {
                              value: "received",
                              name: "Információk átadva"
                            },
                            {
                              value: "saved",
                              name: "Információk rögzítve"
                            },
                            {
                              value: "aborted",
                              name: "Megszakítva"
                            },
                            {
                              value: "done",
                              name: "Sikeres"
                            },
                          ]}
                                    id={"navOnlineStatus"}
                                    optionValue={"value"}
                                    optionLabel={"name"}
                                    showClear
                                    onChange={(e) => {
                                      dt.current.filter(e.value, 'nav_online_status', '');
                                    }}
                                    value={lazyParams.filters.navOnlineStatus.value}
                          />
                        ) : (
                          <Dropdown options={[
                            {
                              value: "processing",
                              name: "Feldolgozása folyamatban"
                            },
                            {
                              value: "received",
                              name: "Információk átadva"
                            },
                            {
                              value: "saved",
                              name: "Információk rögzítve"
                            },
                            {
                              value: "aborted",
                              name: "Megszakítva"
                            },
                            {
                              value: "done",
                              name: "Sikeres"
                            },
                          ]}
                                    id={"navOnlineStatus"}
                                    optionValue={"value"}
                                    optionLabel={"name"}
                                    showClear
                                    onChange={(e) => {
                                      dt.current.filter(e.value, 'nav_online_status', '');
                                    }}
                          />
                        )}
                      </>
                    )
                  }}
          />
        }
        {/* <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column> */}
        {!isPicker && (
          <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"} />
        )}

      </DataTable>
      <div className={"p-grid p-mt-1"}>
        <div className={"p-col-12 p-lg-12 p-xl-12 p-text-right p-col-align-center"}>
          {props.view === 'advanced' &&
            <MultiSelect value={selectedColumnsCut} options={columnsCut} optionLabel="header"
                         onChange={onColumnToggle}
                         selectedItemsLabel="{0} oszlop kiválasztva"
                         placeholder={t('displayPlaceholder')}
                         className={"p-mr-2"}
            />
          }
          {selectedReceipts && selectedReceipts[0] ? (
            <>
              <Button type="button" label={t('download')} icon="pi pi-download"
                      className="p-button-secondary  p-ml-2 p-mt-2 p-mt-xl-0"
                      loading={loading}
                      onClick={() => {
                        setDownloadDialog(true)
                      }}
              />
              <Dialog visible={downloadDialog}
                      style={{width: '950px'}}
                      header={t('downloadReceipts')}
                      modal
                      onHide={() => {
                        setDownloadDialog(false)
                      }}>
                <div className={"p-grid"}>
                  <div className={"p-col-12 p-lg-12 p-xl-12 p-col-align-center"}>
                    <h3 className={"show p-mb-4"}>
                      <i className={"pi pi-file"}></i> Formátum kiválasztása
                    </h3>
                  </div>
                </div>
                <div className={"p-grid"}>
                  <div className={"p-col-12"}>

                    <Dropdown
                      options={[
                        {
                          name: 'PDF',
                          value: 'pdf'
                        },
                        {
                          name: 'XML',
                          value: 'xml'
                        },
                        {
                          name: 'XLSX',
                          value: 'xlsx'
                        },
                      ]}
                      optionLabel="name"
                      optionValue="value"
                      emptyMessage={t('noAvailableFormat')}
                      onChange={(e) => {
                        let _idS = []
                        Object.entries(selectedReceipts).map(function (receipt, index) {
                          _idS.push(receipt[1].id)
                        })
                        axios({
                          method: 'post',
                          url: process.env.REACT_APP_API_HOST + "/receipt/export/" + e.value,
                          data: _idS,
                          params: {},
                          headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                            'App-Network': localStorage.getItem("networkId")
                          }
                        })
                          .then((response) => {
                            window.App.setState({rerenderFilequeueList: true})
                            safeToastShow('success', 'Sikeres művelet!', 'Export kérés rögzítve! Hamarosan letölthető lesz a kért állomány, a befejezésig türelmedet kérjük.');
                          })
                          .catch((error) => {
                            safeToastShow('error', 'Hiba történt!', error.toString());

                          })
                      }}
                    />

                  </div>
                </div>
                <div className={"p-grid p-mt-1"}>
                  <div className={"p-col-12 p-lg-12 p-xl-12 p-col-align-center"}>
                    <h3 className={"show"}>
                      <i className={"pi pi-upload"}></i> {t('exportProcesses')}
                    </h3>
                  </div>
                </div>
                <FilequeueListComponent/>
              </Dialog>
            </>
          ) : (
            <>
              {!isPicker &&
                <Button type="button" label={t('download')} icon="pi pi-download"
                        className="p-button-secondary  p-ml-2 p-mt-2 p-mt-xl-0"
                        loading={loading}
                        onClick={() => {
                          alert('Legalább egy számla kijelölése szükséges!')
                        }}
                />
              }
            </>
          )
          }
          {/* {selectedReceipts && selectedReceipts[0] ? (
              <>
                <Button type="button" label={t('revokeApproval')} icon="pi pi-times"
                        className="p-button-danger  p-ml-2 p-mt-2 p-mt-xl-0"
                        onClick={() => {
                          setLoading(true)
                          let ids = []
                          Object.entries(selectedReceipts).map(function (receipt, index) {
                            ids.push(receipt[1].id)
                          })
                          let data = {
                            method: 'allowed',
                            value: false,
                            receipts: ids
                          }
                          ReceiptBatchService(data)
                            .then(response => {
                              fetchReceiptList(lazyParams)
                                .then(response => {
                                  const data = response.data?.data || {};
                                  setTotalRecords(data.total_item_count || 0);
                                  setReceipt(data.items || []);
                                  setLoading(false);
                                })
                                .catch(error => {
                                  safeToastShow('error', 'Hiba történt!', error.toString());
                                  setLoading(false);
                                })
                            })
                            .catch(error => {
                              safeToastShow('error', 'Hiba történt!', error.toString());
                              setLoading(false);
                            })
                        }}
                />
                <Button type="button" label={t('approve')} icon="pi pi-check"
                        className="p-button-warning  p-ml-2 p-mt-2 p-mt-xl-0"
                        onClick={() => {
                          setLoading(true)
                          let ids = []
                          Object.entries(selectedReceipts).map(function (receipt, index) {
                            ids.push(receipt[1].id)
                          })
                          let data = {
                            method: 'allowed',
                            value: true,
                            receipts: ids
                          }
                          ReceiptBatchService(data)
                            .then(response => {
                              fetchReceiptList(lazyParams)
                                .then(response => {
                                  const data = response.data?.data || {};
                                  setTotalRecords(data.total_item_count || 0);
                                  setReceipt(data.items || []);
                                  setLoading(false);
                                })
                                .catch(error => {
                                  safeToastShow('error', 'Hiba történt!', error.toString());
                                  setLoading(false);
                                })
                            })
                            .catch(error => {
                              safeToastShow('error', 'Hiba történt!', error.toString());
                              setLoading(false);
                            })
                        }}
                />
              </>
            ) : (
              <>
                <Button type="button" label={t('revokeApproval')} icon="pi pi-times"
                        className="p-button-danger  p-ml-2 p-mt-2 p-mt-xl-0"
                        onClick={() => {
                          alert('Legalább egy számla kijelölése szükséges!')
                        }}
                />
                <Button type="button" label={t('approveSelected')} icon="pi pi-check"
                        className="p-button-warning  p-ml-2 p-mt-2 p-mt-xl-0"
                        onClick={() => {
                          alert('Legalább egy számla kijelölése szükséges!')
                        }}
                />
              </>
            )
          }
          {selectedReceipts && selectedReceipts[0] ? (
              <>
                <div className="p-inputgroup p-d-inline p-mt-2 p-mt-xl-0">
                  <InputMask id={"validUntil"}
                             mask={"9999-99-99"}
                             placeholder={t('datePlaceholder')}
                             value={selectedDate}
                             onChange={(e) => {
                               if (e.value.indexOf("_") === -1) {
                                 if (e.value === '') {
                                   e.value = null
                                 }
                                 setSelectedDate(e.value)
                               }
                             }}
                             className={" p-ml-2"}
                             style={{width: '160px'}}
                  />
                  {selectedDate === undefined || selectedDate === null || selectedDate === '' || selectedDate.toString().includes('_') ? (
                    <Button type="button" label={t('columnPaid')} icon="pi pi-check"
                            className="p-button-warning  p-mt-2 p-mt-xl-0"
                            onClick={() => alert(t('paidDateRequired'))}
                    />
                  ) : (
                    <Button type="button" label={t('columnPaid')} icon="pi pi-check"
                            className="p-button-warning  p-mt-2 p-mt-xl-0"
                            onClick={() => {
                              setLoading(true)
                              let ids = []
                              Object.entries(selectedReceipts).map(function (receipt, index) {
                                ids.push(receipt[1].id)
                              })
                              let data = {
                                method: 'is_paid',
                                value: selectedDate,
                                receipts: ids
                              }
                              ReceiptBatchService(data)
                                .then(response => {
                                  fetchReceiptList(lazyParams)
                                    .then(response => {
                                      const data = response.data?.data || {};
                                      setTotalRecords(data.total_item_count || 0);
                                      setReceipt(data.items || []);
                                      setLoading(false);
                                      setSelectedReceipts([])
                                      window.App.setState({rerenderReceiptList: true})
                                    })
                                    .catch(error => {
                                      safeToastShow('error', 'Hiba történt!', error.toString());
                                      setLoading(false);
                                    })
                                })
                                .catch(error => {
                                  safeToastShow('error', 'Hiba történt!', error.toString());
                                  setLoading(false);
                                })
                            }}
                    />
                  )}
                </div>
              </>
            ) : (
              <Button type="button" label={t('columnPaid')} icon="pi pi-check"
                      className="p-button-warning  p-ml-2 p-mt-2 p-mt-xl-0"
                      onClick={() => {
                        alert('Legalább egy számla kijelölése szükséges!')
                      }}
              />
            )
          } */}
        </div>
      </div>
      {props.view === 'advanced' &&
        <div className={"p-grid p-mt-1"}>
          <div className={"p-col-12 p-lg-8"}>

          </div>
          <div className={"p-col-12 p-lg-4"}>
            {sum && sum[0] &&
              <>
                <hr className={"p-mb-3"}/>
                {sum.map((item, index) => {
                  let currency
                  if (item[0].currency === 'HUF') {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: ',',
                      thousand: ' ',
                    }
                  } else {
                    currency = {
                      precision: 2,
                      symbol: '',
                      decimal: '.',
                      thousand: ' ',
                    }
                  }
                  return (
                    <React.Fragment key={index}>
                      <div className={"p-grid"}>
                        <div className={"p-col p-text-right"}>
                          {t('columnNetTotal')}:
                        </div>
                        <div className={"p-col p-text-right"}>
                          {currencyFormatter.format(
                            item[0].sumNet, {
                              precision: currency.precision,
                              symbol: currency.symbol,
                              decimal: currency.decimal,
                              thousand: currency.thousand,
                            }
                          )}&nbsp;{item[0].currency}
                        </div>
                      </div>
                      <div className={"p-grid"}>
                        <div className={"p-col p-text-right"}>
                          {t('vatTotal')}:
                        </div>
                        <div className={"p-col p-text-right"}>
                          {currencyFormatter.format(
                            item[0].sumVat, {
                              precision: currency.precision,
                              symbol: currency.symbol,
                              decimal: currency.decimal,
                              thousand: currency.thousand,
                            }
                          )}&nbsp;{item[0].currency}
                        </div>
                      </div>
                      <div className={"p-grid"}>
                        <div className={"p-col p-text-right"}>
                          {t('grossTotal')}:
                        </div>
                        <div className={"p-col p-text-right"}>
                          {currencyFormatter.format(
                            item[0].sumBr, {
                              precision: currency.precision,
                              symbol: currency.symbol,
                              decimal: currency.decimal,
                              thousand: currency.thousand,
                            }
                          )}&nbsp;{item[0].currency}
                        </div>
                      </div>
                      <hr/>
                    </React.Fragment>
                  )
                })}
              </>
            }
          </div>
        </div>
      }
      <Dialog visible={window.App.state.dialogReceiptDeliverynoteInvoiceCreate}
              style={{width: '750px'}}
              header={t('createCostInvoice')}
              modal
              onHide={() => {
                window.App.setState({dialogReceiptDeliverynoteInvoiceCreate: false})
              }}>
        <ReceiptDeliverynoteInvoiceComponent/>
      </Dialog>
      </Panel>
    </>
  )
}
export default withTranslation('common')(ReceiptListComponent);
